import BaseCollection from "lib/collection";
import Link from "models/catalog/link";

export default BaseCollection.extend({
    mainIndex: "id",
    model: Link,
});
